import deep from 'deep-get-set';
import publicIp from 'react-public-ip';
import { createAction } from 'redux-api-middleware';
import { createSelector } from 'reselect';
import config from '../../config';
import crakIds from '../../constants/crak';
import {
  CAMPAIGN_SUCCESS_PAGE_CREATE_SUCCESS,
  CAMPAIGN_SUCCESS_PAGE_UPDATE_SUCCESS
} from './campaigns';

// Actions
export const CAMPAIGN_INFO_LOAD = 'CAMPAIGN_INFO_LOAD';
export const CAMPAIGN_INFO_LOAD_FAILURE = 'CAMPAIGN_INFO_LOAD_FAILURE';
export const CAMPAIGN_INFO_LOAD_SUCCESS = 'CAMPAIGN_INFO_LOAD_SUCCESS';
export const CAMPAIGN_FULL_QUESTION_HIDE = 'CAMPAIGN_FULL_QUESTION_HIDE';
export const CAMPAIGN_FULL_QUESTION_SHOW = 'CAMPAIGN_FULL_QUESTION_SHOW';
export const PRE_SIGNED_URL_REQUEST_LOAD = 'PRE_SIGNED_URL_REQUEST_LOAD';
export const PRE_SIGNED_URL_REQUEST_FAILURE = 'PRE_SIGNED_URL_REQUEST_FAILURE';
export const PRE_SIGNED_URL_REQUEST_SUCCESS = 'PRE_SIGNED_URL_REQUEST_SUCCESS';
export const BUCKET_UPLOAD_LOAD = 'BUCKET_UPLOAD_LOAD';
export const BUCKET_UPLOAD_FAILURE = 'BUCKET_UPLOAD_FAILURE';
export const BUCKET_UPLOAD_SUCCESS = 'BUCKET_UPLOAD_SUCCESS';
export const CAMPAIGN_COUNT_LOAD = 'CAMPAIGN_COUNT_LOAD';
export const CAMPAIGN_COUNT_LOAD_SUCCESS = 'CAMPAIGN_COUNT_LOAD_SUCCESS';
export const CAMPAIGN_COUNT_LOAD_FAILURE = 'CAMPAIGN_COUNT_LOAD_FAILURE';
export const VIDEO_SELECT = 'VIDEO_SELECT';
export const VIDEO_PROCESSING_SUBMIT = 'VIDEO_PROCESSING_SUBMIT';
export const VIDEO_PROCESSING_SUBMIT_FAILURE = 'VIDEO_PROCESSING_SUBMIT_FAILURE';
export const VIDEO_PROCESSING_SUBMIT_SUCCESS = 'VIDEO_PROCESSING_SUBMIT_SUCCESS';
export const IP_ADDRESS_GET = 'IP_ADDRESS_GET';
export const IP_ADDRESS_GET_FAILURE = 'IP_ADDRESS_GET_FAILURE';
export const IP_ADDRESS_GET_SUCCESS = 'IP_ADDRESS_GET_SUCCESS';
export const CAMPAIGN_PREVIEW_LOAD = 'CAMPAIGN_PREVIEW_LOAD';
export const CAMPAIGN_PREVIEW_LOAD_FAILURE = 'CAMPAIGN_PREVIEW_LOAD_FAILURE';
export const CAMERA_RECORDER_SHOW = 'CAMERA_RECORDER_SHOW';
export const CAMERA_RECORDER_HIDE = 'CAMERA_RECORDER_HIDE';
export const UPLOADED_VIDEO_CLEAR = 'UPLOADED_VIDEO_CLEAR';
export const VIDEO_RECORDING_COMPLETE = 'VIDEO_RECORDING_COMPLETE';
export const VIDEO_POST_ACTION_CANCEL = 'VIDEO_POST_ACTION_CANCEL';
export const CAMPAIGN_ELEMENT_TYPES_LOAD = 'CAMPAIGN_ELEMENT_TYPES_LOAD';
export const CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE = 'CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE';
export const CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS = 'CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS';
export const MEDIA_SUBMISSION_UPDATE_LOAD = 'MEDIA_SUBMISSION_UPDATE_LOAD';
export const MEDIA_SUBMISSION_UPDATE_LOAD_FAILURE = 'MEDIA_SUBMISSION_UPDATE_LOAD_FAILURE';
export const MEDIA_SUBMISSION_UPDATE_LOAD_SUCCESS = 'MEDIA_SUBMISSION_UPDATE_LOAD_SUCCESS';
export const CAMPAIGN_SUBMISSION_SUBMIT = 'CAMPAIGN_SUBMISSION_SUBMIT';
export const CAMPAIGN_SUBMISSION_SUBMIT_FAILURE = 'CAMPAIGN_SUBMISSION_SUBMIT_FAILURE';
export const CAMPAIGN_SUBMISSION_SUBMIT_SUCCESS = 'CAMPAIGN_SUBMISSION_SUBMIT_SUCCESS';
export const CAMPAIGN_ELEMENT_VALUE_UPDATE = 'CAMPAIGN_ELEMENT_VALUE_UPDATE';
export const MEDIA_TYPE_SET = 'MEDIA_TYPE_SET';

export const CAMPAIGN_ELEMENT_CURRENT_LINK_UPDATE = 'CAMPAIGN_ELEMENT_CURRENT_LINK_UPDATE';
export const CAMPAIGN_ELEMENT_TERMS_FETCH_LOAD = 'CAMPAIGN_ELEMENT_TERMS_FETCH_LOAD';
export const CAMPAIGN_ELEMENT_TERMS_FETCH_FAILURE = 'CAMPAIGN_ELEMENT_TERMS_FETCH_FAILURE';
export const CAMPAIGN_ELEMENT_TERMS_FETCH_SUCCESS = 'CAMPAIGN_ELEMENT_TERMS_FETCH_SUCCESS';
export const CAMPAIGN_ELEMENT_CURRENT_LINK_RESET = 'CAMPAIGN_ELEMENT_CURRENT_LINK_RESET';

// Action creators
export const fetchCampaignTerms = (endpoint) =>
  createAction({
    endpoint,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [
      CAMPAIGN_ELEMENT_TERMS_FETCH_LOAD,
      CAMPAIGN_ELEMENT_TERMS_FETCH_SUCCESS,
      CAMPAIGN_ELEMENT_TERMS_FETCH_FAILURE
    ]
  });

export const fetchCampaignInfo = (campaignLink) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.publicCampaignInfo}${campaignLink}?mode=landing`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [CAMPAIGN_INFO_LOAD, CAMPAIGN_INFO_LOAD_SUCCESS, CAMPAIGN_INFO_LOAD_FAILURE]
  });

export const fetchCampaignElementTypes = () =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignElementTypes}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    types: [
      CAMPAIGN_ELEMENT_TYPES_LOAD,
      CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS,
      CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE
    ]
  });

export const putCampaignCount = (campaignId) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignCount}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: campaignId
    }),
    types: [CAMPAIGN_COUNT_LOAD, CAMPAIGN_COUNT_LOAD_SUCCESS, CAMPAIGN_COUNT_LOAD_FAILURE]
  });

export const resetCurrentLinkData = () => ({
  type: CAMPAIGN_ELEMENT_CURRENT_LINK_RESET
});

export function showFullQuestion(qid) {
  return {
    type: CAMPAIGN_FULL_QUESTION_SHOW,
    qid
  };
}

export function hideFullQuestion(qid) {
  return {
    type: CAMPAIGN_FULL_QUESTION_HIDE,
    qid
  };
}

export function loadPreviewData(payload) {
  return {
    type: CAMPAIGN_PREVIEW_LOAD,
    payload
  };
}

export function setPreviewError(message) {
  return {
    type: CAMPAIGN_PREVIEW_LOAD_FAILURE,
    payload: {
      response: {
        message
      }
    }
  };
}

export function updateCampaignElementValue({
  qid,
  value,
  selected,
  attachment,
  isUploading = false
}) {
  return {
    type: CAMPAIGN_ELEMENT_VALUE_UPDATE,
    qid,
    value,
    selected,
    attachment,
    isUploading
  };
}

export const updateCampaignElementCurrentLink = (link) => ({
  type: CAMPAIGN_ELEMENT_CURRENT_LINK_UPDATE,
  link
});

export function showCameraRecorder(qid) {
  return {
    type: CAMERA_RECORDER_SHOW,
    qid
  };
}

export function hideCameraRecorder(qid) {
  return {
    type: CAMERA_RECORDER_HIDE,
    qid
  };
}

export function clearUploadedVideo(qid) {
  return {
    type: UPLOADED_VIDEO_CLEAR,
    qid
  };
}

export function completeRecording(qid) {
  return {
    type: VIDEO_RECORDING_COMPLETE,
    qid
  };
}

export function cancelPostAction(qid) {
  return {
    type: VIDEO_POST_ACTION_CANCEL,
    qid
  };
}

export function setMediaType(qid, mediaType) {
  return {
    type: MEDIA_TYPE_SET,
    qid,
    mediaType
  };
}

// GET a new PreSigned URL for uploading file to S3
// TODO, rename this so we know it generates a pre-signed URL
export const createMediaSubmission = (mediaPayload, qid) =>
  createAction({
    endpoint: `${config.apiHost}/v1/media-submissions/clp`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(mediaPayload),
    types: [
      PRE_SIGNED_URL_REQUEST_LOAD,
      {
        type: PRE_SIGNED_URL_REQUEST_SUCCESS,
        meta: { qid }
      },
      {
        type: PRE_SIGNED_URL_REQUEST_FAILURE,
        meta: { qid },
        payload: (action, state, res) => {
          const contentType = res.headers.get('Content-Type');
          if (contentType?.indexOf('json')) {
            // Just making sure res.json() does not raise an error
            return res.json();
          }
        }
      }
    ]
  });

export const uploadVideoToBucket = (file, preSignedUrl, qid) =>
  createAction({
    endpoint: preSignedUrl,
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
    types: [
      {
        type: BUCKET_UPLOAD_LOAD,
        meta: { qid }
      },
      {
        type: BUCKET_UPLOAD_SUCCESS,
        meta: { qid }
      },
      {
        type: BUCKET_UPLOAD_FAILURE,
        meta: { qid },
        payload: (action, state, res) => {
          const contentType = res.headers.get('Content-Type');
          if (contentType?.indexOf('json')) {
            // Just making sure res.json() does not raise an error
            return res.json();
          }
        }
      }
    ]
  });

export const updateMediaSubmissionStatus = (mediaSubmissionId) =>
  createAction({
    endpoint: `${config.apiHost}/v1/media-submissions/${mediaSubmissionId}`,
    method: 'PATCH',
    body: JSON.stringify({ newStatus: 'UPLOAD_S3' }),
    headers: { 'Content-Type': 'application/json' },
    types: [
      MEDIA_SUBMISSION_UPDATE_LOAD,
      MEDIA_SUBMISSION_UPDATE_LOAD_SUCCESS,
      MEDIA_SUBMISSION_UPDATE_LOAD_FAILURE
    ]
  });

export function selectVideo(qid, objectUrl) {
  return {
    type: VIDEO_SELECT,
    qid,
    objectUrl
  };
}

export const submitCampaignSubmission = (campaignSubmission) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignSubmissions}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(campaignSubmission),
    types: [
      CAMPAIGN_SUBMISSION_SUBMIT,
      CAMPAIGN_SUBMISSION_SUBMIT_SUCCESS,
      CAMPAIGN_SUBMISSION_SUBMIT_FAILURE
    ]
  });

export const previewSubmitCampaignSubmission = (value = true) => {
  return {
    type: CAMPAIGN_SUBMISSION_SUBMIT_SUCCESS,
    value
  };
};

export const getUserIpAddress = () => async (dispatch) => {
  dispatch({ type: IP_ADDRESS_GET });

  try {
    const ip = await publicIp.v4();
    dispatch({ type: IP_ADDRESS_GET_SUCCESS, ip });
  } catch (e) {
    dispatch({ type: IP_ADDRESS_GET_FAILURE, error: e });
  }
};

// Initial state
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  errorMessage: '',
  isTypesLoading: false,
  isTypesLoaded: false,
  isTypesLoadedError: false,
  isTypesLoadedErrorMessage: '',
  elementTypes: {},
  data: {},
  campaignElements: {},
  isSubmittingForProcessing: false,
  isSubmittedForProcessing: false,
  hasProcessingSubmissionError: false,
  processingSubmissionErrorMessage: '',
  uploadPending: false,
  currentLinkData: {}
};

// Reducer helpers
function transformCampaignElements(elements) {
  let prevId = '';
  return elements.reduce((acc, curr, idx) => {
    // Add extra props to curr
    curr.isPreview = false;
    curr.preSignedUrlData = {};
    curr.hasUploadedVideo = false;
    curr.hasUploadFailure = false;
    curr.shouldShowCameraRecorder = false;
    curr.hasRecordedVideo = false;
    curr.shouldShowPostRecordingActions = false;

    prevId = curr.id || idx;
    const currId = curr.id || `${prevId}-preview-${idx}`;

    return {
      ...acc,
      [currId]: curr
    };
  }, {});
}

function reduceElementTypes(data) {
  return data.reduce((prev, curr) => {
    return {
      ...prev,
      [curr.id]: curr.label
    };
  }, {});
}

// Reducers
export function campaignLandingPageReducer(state = initialState, action) {
  switch (action.type) {
    case CAMPAIGN_ELEMENT_TYPES_LOAD: {
      const newState = {
        ...state,
        isTypesLoading: true,
        isTypesLoaded: false,
        isTypesLoadedError: false,
        isTypesLoadedErrorMessage: '',
        elementTypes: {}
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE: {
      const newState = {
        ...state,
        isTypesLoading: false,
        isTypesLoaded: false,
        isTypesLoadedError: true,
        isTypesLoadedErrorMessage: action?.payload?.response?.message,
        elementTypes: {}
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isTypesLoaded: true,
        isTypesLoadedError: false,
        isTypesLoadedErrorMessage: '',
        isTypesLoading: false,
        elementTypes: reduceElementTypes(action.payload.data)
      };

      return newState;
    }

    case CAMPAIGN_INFO_LOAD: {
      const newState = {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
        errorMessage: '',
        data: {},
        campaignElements: {}
      };

      return newState;
    }

    case CAMPAIGN_PREVIEW_LOAD_FAILURE:
    case CAMPAIGN_INFO_LOAD_FAILURE: {
      const newState = {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: true,
        errorMessage: action?.payload?.response?.message
      };

      return newState;
    }

    case CAMPAIGN_PREVIEW_LOAD: {
      const newState = {
        ...state,
        isCampaignPreview: true,
        isLoading: false,
        isLoaded: true,
        error: false,
        errorMessage: '',
        data: {
          ...action.payload,
          campaignElements: undefined // toss these out we'll move them up to the root
        },
        campaignElements: transformCampaignElements(action.payload.campaignElements)
      };

      return newState;
    }

    case CAMPAIGN_INFO_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: false,
        errorMessage: '',
        data: {
          ...action.payload,
          campaignElements: undefined // toss these out we'll move them up to the root
        },
        campaignElements: transformCampaignElements(action.payload.campaignElements)
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_VALUE_UPDATE: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            value: action.value,
            selected: action.selected,
            attachment: action?.attachment,
            isUploading: action?.isUploading
          }
        }
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_CURRENT_LINK_UPDATE: {
      const newState = {
        ...state,
        currentLinkData: {
          ...state?.currentLinkData,
          link: action.link
        }
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_CURRENT_LINK_RESET: {
      const newState = {
        ...state,
        currentLinkData: {}
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TERMS_FETCH_LOAD: {
      const newState = {
        ...state,
        currentLinkData: {
          ...state?.currentLinkData,
          isLoading: true,
          error: false
        }
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TERMS_FETCH_SUCCESS: {
      const newState = {
        ...state,
        currentLinkData: {
          ...state?.currentLinkData,
          isLoading: false,
          data: action.payload
        }
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TERMS_FETCH_FAILURE: {
      const newState = {
        ...state,
        currentLinkData: {
          ...state?.currentLinkData,
          isLoading: false,
          error: true
        }
      };

      return newState;
    }

    case CAMPAIGN_FULL_QUESTION_SHOW: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            isPreview: false
          }
        }
      };

      return newState;
    }

    case CAMPAIGN_FULL_QUESTION_HIDE: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            isPreview: true
          }
        }
      };

      return newState;
    }

    case CAMERA_RECORDER_SHOW: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            shouldShowCameraRecorder: true,
            // Reset video upload reference
            hasUploadedVideo: false,
            uploadPending: false
          }
        }
      };

      return newState;
    }

    case CAMERA_RECORDER_HIDE: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            shouldShowCameraRecorder: false
          }
        }
      };

      return newState;
    }

    case PRE_SIGNED_URL_REQUEST_FAILURE: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.meta.qid]: {
            ...state.campaignElements[action.meta.qid],
            hasSigningError: true,
            preSignedUrlData: action.payload
          }
        }
      };

      return newState;
    }

    case PRE_SIGNED_URL_REQUEST_SUCCESS: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.meta.qid]: {
            ...state.campaignElements[action.meta.qid],
            hasSigningError: false,
            preSignedUrlData: action.payload
          }
        }
      };

      return newState;
    }

    case BUCKET_UPLOAD_LOAD: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.meta.qid]: {
            ...state.campaignElements[action.meta.qid],
            hasUploadedVideo: false,
            hasUploadFailure: false,
            isUploading: true
          }
        }
      };

      return newState;
    }

    case BUCKET_UPLOAD_SUCCESS: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.meta.qid]: {
            ...state.campaignElements[action.meta.qid],
            hasUploadedVideo: true,
            hasUploadFailure: false,
            // Let's close the "accordion" on upload success
            isPreview: true,
            isUploading: false,
            shouldShowCameraRecorder: false,
            shouldShowPostRecordingActions: false,
            uploadPending: false
          }
        }
      };
      return newState;
    }

    case BUCKET_UPLOAD_FAILURE: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.meta.qid]: {
            ...state.campaignElements[action.meta.qid],
            hasUploadedVideo: false,
            hasUploadFailure: true,
            isUploading: false,
            uploadPending: false,
            bucketUploadError: action.payload
          }
        }
      };
      return newState;
    }

    case VIDEO_SELECT: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            videoPreview: action.objectUrl
          }
        }
      };

      return newState;
    }

    case MEDIA_TYPE_SET: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            mediaType: action.mediaType
          }
        }
      };

      return newState;
    }

    case CAMPAIGN_SUBMISSION_SUBMIT: {
      const newState = {
        ...state,
        isSubmittingForProcessing: true,
        hasProcessingSubmissionError: false,
        processingSubmissionErrorMessage: ''
      };
      return newState;
    }
    case CAMPAIGN_SUBMISSION_SUBMIT_FAILURE: {
      const newState = {
        ...state,
        isSubmittingForProcessing: false,
        isSubmittedForProcessing: false,
        hasProcessingSubmissionError: true,
        processingSubmissionErrorMessage: action?.payload?.response?.message
      };

      return newState;
    }

    case CAMPAIGN_SUBMISSION_SUBMIT_SUCCESS: {
      const newState = {
        ...state,
        isSubmittingForProcessing: false,
        isSubmittedForProcessing: true
      };

      return newState;
    }

    case IP_ADDRESS_GET_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          ipAddress: action.ip
        }
      };

      return newState;
    }

    case UPLOADED_VIDEO_CLEAR: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            hasUploadedVideo: false,
            uploadPending: false
          }
        }
      };

      return newState;
    }

    case VIDEO_RECORDING_COMPLETE: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            hasRecordedVideo: true,
            shouldShowPostRecordingActions: true,
            uploadPending: true
          }
        }
      };

      return newState;
    }

    case VIDEO_POST_ACTION_CANCEL: {
      const newState = {
        ...state,
        campaignElements: {
          ...state.campaignElements,
          [action.qid]: {
            ...state.campaignElements[action.qid],
            hasRecordedVideo: false,
            shouldShowPostRecordingActions: false,
            shouldShowCameraRecorder: false,
            hasUploadFailure: false,
            hasSigningError: false,
            uploadPending: false
          }
        }
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_CREATE_SUCCESS:
    case CAMPAIGN_SUCCESS_PAGE_UPDATE_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: action.payload
        }
      };
      return newState;
    }

    default: {
      return state;
    }
  }
}

// Selectors
export const getCampaignLandingState = createSelector(
  (state) => state,
  (state) => state.get('campaignLanding')
);

export const getIsCampaignLandingLoading = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'isLoading')
);

export const getIsCampaignLandingLoaded = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'isLoaded')
);

export const getCampaignLandingHasError = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'error')
);

export const getCampaignLandingErrorText = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'errorMessage')
);

export const getCampaignLandingData = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'data')
);

export const getCampaignName = createSelector(
  getCampaignLandingData,
  (data) => deep(data, 'name') || ''
);

export const getCampaignId = createSelector(
  getCampaignLandingData,
  (data) => deep(data, 'campaignId') || null
);

export const getCampaignDescription = createSelector(
  getCampaignLandingData,
  (data) => deep(data, 'description') || ''
);

export const getIpAddress = createSelector(
  getCampaignLandingData,
  (data) => deep(data, 'ipAddress') || '0.0.0.0'
);

export const getCustomCampaignSuccessPageData = createSelector(
  getCampaignLandingData,
  (data) => deep(data, 'campaignSuccessPage') || null
);

export const getCampaignElements = createSelector(getCampaignLandingState, (campaignLandingState) =>
  deep(campaignLandingState, 'campaignElements')
);

export const getHasTermsSignatureElement = createSelector(
  getCampaignElements,
  (campaignElements) => {
    const campaignElementValues = campaignElements || {};
    for (const prop in campaignElementValues) {
      if (campaignElementValues[prop]?.crakId === crakIds.SIGNATURE) {
        return true;
      }
    }
    return false;
  }
);

export const getCampaignElementTypes = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'elementTypes')
);

export const getCampaignElementIds = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => Object.keys(campaignLandingState.campaignElements)
);

export const getCampaignLandingOrganizationId = createSelector(
  getCampaignLandingData,
  (data) => data?.organizationId
);

export const getCampaignElementById = createSelector(
  (state) => getCampaignLandingState(state),
  (state, questionId) => questionId,
  (state, questionId) => {
    const campaignElements = deep(state, 'campaignElements') || {};

    return campaignElements[questionId];
  }
);

export const getTermsConditionsElementId = createSelector(
  getCampaignElements,
  (campaignElements) => {
    const campaignElementValues = campaignElements || {};
    for (const prop in campaignElementValues) {
      if (campaignElementValues[prop]?.crakId === crakIds.TERMS_AND_CONDITIONS_INPUT) {
        return prop;
      }
    }
    return '';
  }
);

export const getIsQuestionPreview = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'isPreview')
);

export const getHasSigningError = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'hasSigningError') || null
);

export const getPresignedError = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'preSignedUrlData.message') || null
);

export const getBucketUploadError = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'bucketUploadError.message') || null
);

export const getPreSignedUrlForUpload = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'preSignedUrlData.presignedUrl') || null
);

export const getMediaSubmissionIdForElement = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'preSignedUrlData.mediaSubmissionId') || null
);

export const getHasUploadedVideoForQuestionId = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'hasUploadedVideo')
);

export const getIsVideoUploadingToBucket = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'isUploading')
);

export const getHasVideoBucketUploadFailed = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'hasUploadFailure')
);

export const getVideoPreview = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'videoPreview')
);

export const getReadyToSubmit = createSelector(getCampaignLandingState, (campaignLandingState) => {
  const elementsObject = deep(campaignLandingState, 'campaignElements') || {};
  const elements = Object.values(elementsObject);
  for (let element of elements) {
    if (
      element.isUploading ||
      (element.required &&
        !(element.value || element.hasUploadedVideo || element.selected || element.attachment)) ||
      element.uploadPending
    ) {
      return false;
    }
  }

  return true;
});

export const getIsSubmittingForProcessing = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'isSubmittingForProcessing')
);

export const getHasSubmittedForProcessing = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'isSubmittedForProcessing')
);

export const getHasLoadingError = createSelector(getCampaignLandingState, (campaignLandingState) =>
  deep(campaignLandingState, 'error')
);

export const getHasProcessingSubmissionError = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'hasProcessingSubmissionError')
);

export const getProcessingSubmissionErrorMessage = createSelector(
  getCampaignLandingState,
  (state) => state?.processingSubmissionErrorMessage
);

export const getLoadingErrorMessage = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'errorMessage')
);

export const getShouldShowCameraRecorder = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'shouldShowCameraRecorder')
);

export const getShouldShowPostRecordingActions = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'shouldShowPostRecordingActions')
);

export const getMediaTypeForQid = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (question) => deep(question, 'mediaType')
);

export const getVideoDesignElementUrl = createSelector(
  (state, questionId) => getCampaignElementById(state, questionId),
  (element) => deep(element, 'media.rawPath') || null
);

export const getIsCampaignPreview = createSelector(
  getCampaignLandingState,
  (campaignLandingState) => deep(campaignLandingState, 'isCampaignPreview')
);

export const getCurrentLinkData = createSelector(
  getCampaignLandingState,
  (state) => state?.currentLinkData
);

export const getCampaignCustomDomain = createSelector(
  getCampaignLandingState,
  (state) => state?.data?.campaign_domain?.domain
);

export const getIsClpDownloadEnabled = createSelector(
  getCampaignLandingState,
  (state) => state?.data?.isDownloadAllowed
);



// WEBPACK FOOTER //
// ./src/redux/modules/campaignLandingPage.js